import * as ActionTypes from "../actions/ActionTypes";

const initialState = {
    loginUserData: {
        loggedIn: false,
        username: "",
        name: "",
        domainId: null,
        roles:[]
    },

};

export default function authReducer(state = initialState, action) {

    if (action === undefined) {
        return state;
    }

    switch (action.type) {
        case ActionTypes.LOGIN_SUCCESS :
            return Object.assign({}, state, {loginUserData: action.payload});
        case ActionTypes.LOGOUT_SUCCESS :
            return Object.assign({}, state, {loginUserData: action.payload});
        default:
            return state;
    }
}
